import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=2c755724&scoped=true&"
import script from "./publications.ts?vue&type=script&lang=ts&"
export * from "./publications.ts?vue&type=script&lang=ts&"
import style0 from "./publications.scss?vue&type=style&index=0&id=2c755724&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c755724",
  null
  
)

export default component.exports